import $ from 'jquery';
import 'slick-carousel';
import breakpoint from '../util/breakpoint';

$('.slider').each((i, elt) => {
  /**
   * Breakpoints are defined as "mobile first" but implemented in slick carousel as "responsive"
   * slick carousel has a mobile first option but it's buggy
   */
  const slides = $(elt).attr('data-slides-xs') || 1;
  const slidesSm = $(elt).attr('data-slides-sm') || slides;
  const slidesMd = $(elt).attr('data-slides-md') || 2;
  const slidesLg = $(elt).attr('data-slides-lg') || slidesMd;
  const slidesXl = $(elt).attr('data-slides-xl') || 3;
  const slidesXxl = $(elt).attr('data-slides-xxl') || slidesXl;
  const prevText = $(elt).attr('data-txt-prev') || 'Précédent';
  const nextText = $(elt).attr('data-txt-next') || 'Suivant';

  $(elt).slick({
    dots: false,
    infinite: true,
    slidesToShow: slidesXxl,
    slidesToScroll: 1,
    prevArrow: `<button class="button button-round slider-button slider-prev" type="button">
        <span class="sr-hidden icon icon-arrow-left" aria-hidden="true"></span>
        <span class="sr-only">${prevText}</span>
      </button>`,
    nextArrow: `<button class="button button-round slider-button slider-next" type="button">
        <span class="sr-hidden icon icon-arrow-right" aria-hidden="true"></span>
        <span class="sr-only">${nextText}</span>
      </button>`,
    responsive: [
      {
        breakpoint: breakpoint.breakpoints.width.xl,
        settings: {
          slidesToShow: slidesXl,
        },
      },
      {
        breakpoint: breakpoint.breakpoints.width.lg,
        settings: {
          slidesToShow: slidesLg,
        },
      },
      {
        breakpoint: breakpoint.breakpoints.width.md,
        settings: {
          slidesToShow: slidesMd,
        },
      },
      {
        breakpoint: breakpoint.breakpoints.width.sm,
        settings: {
          slidesToShow: slidesSm,
        },
      },
      {
        breakpoint: breakpoint.breakpoints.width.xs,
        settings: {
          slidesToShow: slides,
        },
      },
    ],
  });
});



// WEBPACK FOOTER //
// ./scripts/components/Sliders.js